$(window).load(function() {
  
  sameHeight('.selling-chart-main-wrap .selling-heading');
//   sameHeight('.selling-chart-main-wrap .selling-content-day');
//   sameHeight('.selling-chart-main-wrap .selling-content');
  
});


$(window).resize(function(){
  sameHeight('.selling-chart-main-wrap .selling-heading');
//   sameHeight('.selling-chart-main-wrap .selling-content-day');
//   sameHeight('.selling-chart-main-wrap .selling-content');
});


function sameHeight(selector) {
  var highestBox = 0;
  $(selector).each(function(){  
    if($(this).height() > highestBox){  
      highestBox = $(this).height();  
    }

  });    
  if(highestBox == 0){
  highestBox = 18
  }
  $(selector).height(highestBox);
}